$(document).on('shopify:section:load', function() {
    socials_v2();
});

$(document).ready(function() {
    socials_v2();
});

$(window).scroll(function() {
    socials_v2();
});

function socials_v2() {
    if ($('.socials-v2').length) {
        $('.socials-v2').each(function() {
            let el = $(this);
        
            if (visiblePercent(el) > 20) {
                el.find('.aos-init').addClass('aos-animate');
            }
            else {
                el.find('.aos-init').removeClass('aos-animate');
            }

        });    
    }
}

$('.page-banner + .form-wrapper .open-form').on('click', function() {
    $('html').css('overflow', 'hidden');
    $('.page-banner + .form-wrapper + .popup-form').fadeIn();
});

$('.page-banner + .form-wrapper + .popup-form .overlay, .page-banner + .form-wrapper + .popup-form .form-close').on('click', function() {
    $('html').css('overflow', 'auto');
    $('.page-banner + .form-wrapper + .popup-form').fadeOut();
});

$('.page-banner + .form-wrapper + .popup-form .form-container select.form-input').on('change', function() {
    $(this).css('color', '#1a1a1a');
});